import {Tooltip} from "@material-ui/core";
import ShowChart from "@material-ui/icons/ShowChart";
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import RemoveIcon from '@material-ui/icons/Remove';
import {Button} from "reactstrap";
import React from "react";

export default function FDCountDisplay({type, count, triggerModal, showChart = true}) {
	const trend = window.localStorage.getItem(`${type}_trend`);
	return (
		<React.Fragment>
			{showChart && <Tooltip title={"Show FD graphs"}>
				<Button size={'sm'} color={"info"} onClick={() => {
					if (typeof (triggerModal) === 'function') {
						triggerModal();
					}
				}}>
					<ShowChart fontSize={"small"}/>
				</Button>
			</Tooltip>}
			<a style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}} target={"_blank"} href={type === 'pending' ? "https://karlstechnology.freshdesk.com/a/tickets/filters/1000269762" : "https://karlstechnology.freshdesk.com/a/tickets/filters/1000262124"}>
				<p style={{marginBottom: 0, color: count > (type === 'pending' ? 30 : 10) ? 'red' : 'green', fontWeight: showChart ? 'initial' : 'bold', fontSize: showChart ? 'initial' : '18px'}}>
					{type === 'pending' ? 'Pending' : 'Dispatch'} Tickets: {count}
				</p>
				<TrendArrow trend={trend}/>
			</a>

		</React.Fragment>
	)
}

function TrendArrow({ trend }) {
	if (trend === 'up') {
		return <ArrowUpwardIcon style={{ color: '#DC3545FF' }} />; // green
	} else if (trend === 'down') {
		return <ArrowDownwardIcon style={{ color: '#28A745FF' }} />; // red
	} else {
		return <RemoveIcon style={{ color: '#FFC107FF' }} />; // gray neutral
	}
}